import * as React from 'react'
import { Divider, ListItem, ListItemText } from 'cs-kevlar-react'
import { PageDefinition } from 'pages/pageDefinition'
import { Location } from 'history'
import { matchPath } from 'react-router-dom'
import { WebAdminUser } from '../../api'
import clsx from 'clsx'

interface NavLinkProps {
  page: PageDefinition
  location: Location
  className: string
  selectedClassName: string
  navigate: (page: PageDefinition) => void
  user: WebAdminUser | null
}

export const NavLink: React.FunctionComponent<NavLinkProps> = ({
  page,
  location,
  className,
  selectedClassName,
  navigate,
  user,
}) => {
  if (!page.canAccess(user)) return null

  let isCurrentRoute = false
  for(let route of page.routes(user)) {
    const match = matchPath({
      path: route,
      caseSensitive: true,
    }, location.pathname)

    if(match !== null) {
      isCurrentRoute = true
      break
    }
  }  

  return (
    <React.Fragment>
      <ListItem
        button
        onClick={() => navigate(page)}
        className={clsx(className, isCurrentRoute && selectedClassName)}
      >
        <ListItemText>{page.navLinkText}</ListItemText>
      </ListItem>
      <Divider />
    </React.Fragment>
  )
}
